jQuery(document).ready(function ($) {
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    var header = $(".header-wrapper");
    if (scroll >= 60) {
      header.addClass("is-scrolled");
    } else {
      header.removeClass("is-scrolled");
    }
  });

  // Toggles scroll-to-top button
  $(document).on("scroll", function () {
    if ($(window).scrollTop() > 300) {
      $(".scroll-top-wrapper").addClass("show");
    } else {
      $(".scroll-top-wrapper").removeClass("show");
    }
  });

  // Scrolls to top on click
  $(".scroll-top-wrapper").on("click", scrollToTop);

  function scrollToTop() {
    verticalOffset = typeof verticalOffset != "undefined" ? verticalOffset : 0;
    element = jQuery("body");
    offset = element.offset();
    offsetTop = offset.top;
    $("html, body").animate(
      {
        scrollTop: offsetTop,
      },
      250,
      "linear"
    );
  }

  $("a[href^='#']").on("click", function (e) {
    // prevent standard hash navigation (avoid blinking in IE)
    e.preventDefault();

    // target element id
    var id = $(this).attr("href");

    // target element
    var $id = $(id);
    if ($id.length === 0) {
      return;
    }

    // top position relative to the document
    var pos = $id.offset().top;

    // animated top scrolling
    $("body, html").animate({ scrollTop: pos });
  });
});
